
import { take, takeEvery, takeLatest } from '@zaibot/fsa-saga';
import 'arrayq';
import { createSelector } from 'reselect';

import { AnchorNode, findClosestAnchorNode, getAnchorFromDocument } from '../../anchor/index';
import { hack } from '../../browser/launch';
import { applyHighlights, removeHighlights } from '../../highlight';
import { selectors as metaSelectors } from '../../meta/selectors';
import { call, cancel, delay, fork, put, select } from '../../redux-saga';
import { ICategory, IEntityNote, INote, INoteChat, INoteShared, IParticipant, IQuestion, IQuestionDB, isNote, isQuestion, isSharedNote } from '../../types';
import { categoriesResource } from '../categories/resource';
import { notesAndQuestionsPageSelector, notesCurrentPageSelector } from '../pageFilter/selectors';
import selectionSelectors from '../selection/selectors';
import currentitem from './selectors';

import { notesBatch, notesEditor, notesResource } from './resource';
import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../../auth/actions/LOGGEDOUT';
import READY from '../../browser/actions/READY';
import FLYOVER_HIDE from '../flyover/actions/HIDE';
import PAGEFILTER_CHANGE_CATEGORY from '../pageFilter/actions/CHANGE_CATEGORY';
import PAGEFILTER_CHANGE_SORTING from '../pageFilter/actions/CHANGE_SORTING';
import SELECTION_SUCCESS from '../selection/actions/SUCCESS';
import SELECTION_RESET from '../selection/actions/RESET';
import SELECTION_REQUEST from '../selection/actions/REQUEST';
import NOTES_REDRAW from './actions/NOTES_REDRAW';
import HIDE_SELECT_POPUP from '../categorySelectPopup/actions/HIDE';
import cx from './style.less';

const timeoutContentNav = 1500;
const delayafterreload = 1500;
const maxDelayTime = 10000;
const minDelayTime = 1000;

export function* rootSaga(): Iterable<any> {
    yield fork(notesResource.saga);
    yield fork(notesEditor.saga);
    yield fork(notesBatch.saga);
    yield fork(signalNotesList);
    yield fork(signalNotesReset);
    yield fork(monitorSelectedNote);
    yield fork(monitorSelectedCategory);
    yield fork(monitorHighlightNoteOnCreate);
    yield fork(monitorBrowserReady);
    yield fork(monitorNoteHighlights);   
    yield fork(monitorBrowserRestoreActiveNote);
    yield fork(signalDeleteNoteWithChats);
    yield fork(signalDeleteBatchNotes);
}
 
function* signalDeleteBatchNotes() {
    yield takeEvery(NOTES_DELETE_BATCH, function*(action) {
        if (isType(action, NOTES_DELETE_BATCH)) {
            let notes = action.payload.items.qWhere((itm) => !(isSharedNote(itm)));
            if (notes) {
                var countNotesToUpdate = notes.length;
                if (countNotesToUpdate>0) {
                    try { 
                        for (var note of notes) {                          
                            yield put(NOTE_DELETE_WITH_CHAT({item: note}));
                            const waiting: RaceEffect = yield race({
                                timeout: call(delay, maxDelayTime),
                                updateend: take([notesResource.actions.DELETE_FAILURE, notesResource.actions.DELETE_SUCCESS]),
                            });   
                            let waitresult: any = waiting;                
                            if (waitresult.updateend) {
                                if (countNotesToUpdate>0) {
                                    countNotesToUpdate--;
                                    if (countNotesToUpdate===0) {
                                        yield call(delay, minDelayTime),
                                        yield put(NOTES_DELETE_BATCH_COMPLETE({items: undefined, batchdelete: false}));
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        // tslint:disable-next-line                  
                        console.log(error); 
                        yield put(NOTES_DELETE_BATCH_FAILURE({items: undefined, batchdelete: false}));
                    }
                }   
            }
        }
    });
}

function* signalDeleteNoteWithChats() {
    yield takeEvery(NOTE_DELETE_WITH_CHAT, function*(action) {
        if (isType(action, NOTE_DELETE_WITH_CHAT)) {
            let note = action.payload.item;
            if (!(isSharedNote(note))) {
                const notechats: INoteChat[] = yield select(notechatResource.selectors.items);
                const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);
                var notechatsNotes = notechats.qWhere((itm) => itm.noteId === note.id);
                var countNotesToUpdate = notechatsNotes.length;
                var questionNote = questions.qFirst((itm) => itm.noteId === note.id);
                // To eliminate FK_... errors delete notechats in notes.
                if (countNotesToUpdate>0) {
                    try { 
                        for (var notechat of notechatsNotes) {                          
                            yield put(notechatEditor.actions.DELETE_CONTINUE({item: notechat}));
                            const waiting: RaceEffect = yield race({
                                timeout: call(delay, maxDelayTime),
                                updateend: take([notechatResource.actions.DELETE_FAILURE, notechatResource.actions.DELETE_SUCCESS]),
                            });   
                            let waitresult: any = waiting;                
                            if (waitresult.updateend) {
                                if (countNotesToUpdate>0) {
                                    countNotesToUpdate--;
                                    if (countNotesToUpdate===0) {                                     
                                        if (questionNote) {
                                            yield put(questionsEditor.actions.DELETE_CONTINUE({item: questionNote}));
                                        }
                                        yield call(delay, minDelayTime);   
                                        yield put(notesEditor.actions.DELETE_CONTINUE({item: note}));

                                        // yield call(delay, minDelayTime),
                                        // yield put(notesEditor.actions.DELETE_CONTINUE({item: note}));

                                    }
                                }
                            }
                        }
                    } catch (error) {
                        // tslint:disable-next-line                  
                        console.log(error);        
                    }
                } else {
                    if (questionNote) {
                        yield put(questionsEditor.actions.DELETE_CONTINUE({item: questionNote}));
                    }
                    yield call(delay, minDelayTime);   
                    yield put(notesEditor.actions.DELETE_CONTINUE({item: note}));
                }      
            }
        }
    });
}

function* signalNotesList() {
    yield takeEvery([AUTHENTICATED], function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        const documentId = selectionDocumentId;
        yield put(notesResource.actions.LIST({ params: { documentId } }));
    }); 
    yield takeEvery([USERGROUP_CREATED, 
        USERGROUP_UPDATED], function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        const documentId = selectionDocumentId;
        yield put(notesResource.actions.LIST({ params: { documentId } }));
    });     
    yield takeEvery([beheerResource.actions.CREATE_SUCCESS, 
        beheerResource.actions.UPDATE_SUCCESS], function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        const documentId = selectionDocumentId;
        yield put(notesResource.actions.LIST({ params: { documentId } }));
    });        
}

function* monitorSelectedNote() {
    yield takeEvery(notesEditor.actions.READ, function*(action) {
        let selectionPage: SelectEffect = yield select(metaSelectors.pageId);
        let selectionPageId: any = selectionPage;
        const pageId = selectionPageId;
        if (action.payload.item.pageId !== pageId) {
            window.location.href = action.payload.item.url;
        } else {
            yield call(monitorScrollToNote, action.payload.item);
        }
    });
    yield takeEvery(notesSharedEditor.actions.READ, function*(action) {
        let selectionPage: SelectEffect = yield select(metaSelectors.pageId);
        let selectionPageId: any = selectionPage;
        const pageId = selectionPageId;
        if (action.payload.item.pageId !== pageId) {
            window.location.href = action.payload.item.url;
        } else {
            yield call(monitorScrollToNote, action.payload.item);
        }
    });    
}

function* monitorSelectedCategory() {
    yield takeEvery(notesEditor.actions.APPLY, function*(action) {
        yield put(HIDE_SELECT_POPUP({}));
    });
}

function* monitorHighlightNoteOnCreate() {
    yield takeLatest(notesEditor.actions.CREATE, function*(action) {
        removeHighlights(document.documentElement, '.js-highlight');
        try {
            const note: INote = yield select(notesEditor.selectors.item);
            yield applyHighlights(getAnchorFromDocument(), note.startElementXPath, note.endElementXPath, (node) =>  {
                node.className = `${cx('highlight', 'highlight-active')} js-highlight`;
            });
            yield call(monitorScrollToNote, note);
        } catch (ex) {
            // tslint:disable-next-line
            console.error(`[Notes] Update creating highlights failed.`, ex);
        }

        yield take([notesEditor.actions.CREATE, notesEditor.actions.CREATE_CANCEL, notesEditor.actions.CREATE_CONTINUE, notesEditor.actions.RESET]);
        removeHighlights(document.documentElement, '.js-highlight');
    });
}

function* monitorBrowserReady() {
    yield takeEvery(READY, function*(action) {
        const itemEff: SelectEffect = yield select(notesEditor.selectors.item);
        const item: any = itemEff;
        const readingEff: SelectEffect = yield select(notesEditor.selectors.reading);
        const reading: any = readingEff;        
        const questionsEff: SelectEffect = yield select(questionsResource.selectors.items);
        const questions: any = questionsEff;  

        if (item && reading) {
            const pageIdEff: SelectEffect = yield select(metaSelectors.pageId);
            const pageId: any = pageIdEff;   
            if (item.pageId === pageId) {
                yield call(monitorScrollToNote, item);
                // Fix voor id lost in @redux-saga/id not set
                // yield put(notesEditor.actions.READ_CANCEL({ }));
                // console.log("READ_CANCEL");
            } else {
                yield put(notesEditor.actions.RESET({}));
                yield put(questionsEditor.actions.RESET({}));
            }
        } else if (item) {
            const pageIdEff: SelectEffect = yield select(metaSelectors.pageId);
            const pageId: any = pageIdEff;  
            if (item.pageId === pageId) {
                yield put(notesEditor.actions.READ({item}));
                if (isQuestion(item)) {                            
                    var current = questions.qWhere((x: IQuestionDB) => x.noteId === item.id).qFirst();
                    if (current) {  
                        yield put(questionsEditor.actions.READ({ item: current })); 
                    }
                }
            } else {
                yield put(notesEditor.actions.RESET({}));
                yield put(questionsEditor.actions.RESET({}));
            }
        }

    });
}

// Integration with the website
interface IContentNav {
    activate(selector: string | Node, callback?: () => void): void;
}
async function contentNavActivate(el: Node) {
    return new Promise<void>((resolve, reject) => {
        try {
            const cn: IContentNav = (window as any).ContentNav;
            if (cn) {
                const timer = setTimeout(() => {
                    // tslint:disable-next-line
                    console.error(`[Notes] ContentNav timed out`);
                    resolve();
                }, timeoutContentNav);
                cn.activate(el, () => {
                    resolve();
                    clearTimeout(timer);
                });
            } else {
                resolve();
            }
        } catch (ex) {
            reject(ex);
        }
    });
}

/* tslint:disable */
const bezier = require('bezier');
const cubic = bezier.prepare(4);
import { constrain, map_constrain } from '@zaibot/mathlib';
import { getSelectionDetail } from "../../abstractselection/index";
import { buttonNoSelection } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import { isType } from '@zaibot/fsa';
import SESSION_RESTORED from '../../browser/actions/SESSION_RESTORED';
import NOTES_ITEM_LAST_TOUCHED from './actions/NOTES_ITEM_LAST_TOUCHED';
import { notesSharedEditor, notesSharedResource } from '../noteshared/resource';
import { participantsResource } from '../../participant/resource';
import { ForkEffect, race, RaceEffect, SelectEffect } from 'redux-saga/effects';
import { PublisherSpecific } from '../../publisherspecific/publisherspecific';
import NOTE_DELETE_WITH_CHAT from './actions/NOTE_DELETE_WITH_CHAT';
import { notechatEditor, notechatResource } from '../notechat/resource';
import NOTES_DELETE_BATCH from './actions/NOTES_DELETE_BATCH';
import NOTES_DELETE_BATCH_COMPLETE from './actions/NOTES_DELETE_BATCH_COMPLETE';
import NOTES_DELETE_BATCH_FAILURE from './actions/NOTES_DELETE_BATCH_FAILURE';
import { questionsEditor, questionsResource } from '../question/resource';
import TAB_ACTIVATE from '../flyover/actions/TAB_ACTIVATE';
import USERGROUP_UPDATED from '../../usergroup/actions/USERGROUP_UPDATED';
import USERGROUP_CREATED from '../../usergroup/actions/USERGROUP_CREATED';
import { beheerResource } from '../../admin/resource';
import React from 'react';

let scrollTask: any;
function* monitorScrollToNote(note: IEntityNote) {    
    if (scrollTask) {
        yield cancel(scrollTask);
    }
    if (!note) {
        return;
    }
    const pageIdEff:SelectEffect = yield select(metaSelectors.pageId);
    const pageId:any = pageIdEff  
    if (note.pageId !== pageId) {
        return;
    }

    let scrollTaskEff:ForkEffect = yield fork(function*() {
        // Scroll to activated note
        try {
            const detailsNav = getSelectionDetail(getAnchorFromDocument(), note.startElementXPath);
            if (!detailsNav) { return; }
            try {
                yield contentNavActivate(detailsNav.textStart);
            } catch (ex) {
                // tslint:disable-next-line
                console.error(`[Notes] ContentNav failed`, ex);
            }

            // Search anchors again, DOM sometimes changes due to website JS
            const details = getSelectionDetail(getAnchorFromDocument(), note.startElementXPath);
            if (!details) {
                console.error(`[Notes] selection details not found after ContentNav for [${note.startElementXPath}]`);
                return;
            }
            const fps = 60;
            const duration = 300;
            const maxDuration = 600;
            var ps = new PublisherSpecific();
            var detailselement = (details.textStart.parentNode as Element);
            if (detailselement&&!ps.isVisible(detailselement as Element)) {
                while (detailselement&&!ps.isVisible(detailselement)) {
                    detailselement = detailselement.parentNode as Element;
                }
                if (!detailselement) detailselement=(details.textStart.parentNode as Element);
            };
            const detailsTop = detailselement.getBoundingClientRect().top;
            //const detailsTop = (details.textStart.parentNode as Element).getBoundingClientRect().top;
            const scrollingElement = document.scrollingElement || document.documentElement;
            const scrollTopStart = scrollingElement.scrollTop;
            const scrollHeight = scrollingElement.scrollHeight;
            const viewportHeight = window.innerHeight;
            const targetY = constrain(Math.floor(scrollTopStart + detailsTop - viewportHeight * .33), 0, scrollHeight - viewportHeight);

            const time = Date.now();
            const diffY = targetY - scrollTopStart;
            const bezierInput = [0, diffY * .1, diffY * .9, diffY];
            let scrollTop = scrollTopStart;
            while (scrollTop !== targetY && (Date.now() - time) < maxDuration) {
                const t = map_constrain(Date.now() - time, 0, duration, 0, 1);
                scrollTop = scrollTopStart + cubic(bezierInput, t);
                document.documentElement.scrollTop = scrollTop;
                document.body.scrollTop = scrollTop;
                yield delay(1000 / fps);
            }
        } catch (ex) {
            // tslint:disable-next-line
            console.debug(`[Notes] Unable to get selection details for [${note.startElementXPath}]`, ex);
        }
    });
    scrollTask = scrollTaskEff;
}
/* tslint:enable */

function* signalNotesReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(notesEditor.actions.RESET({}));
        yield put(notesResource.actions.RESET({}));
    });
}

function getCategoryCss(activeNote: IEntityNote, note: IEntityNote) {   
    if (isSharedNote(activeNote) && isSharedNote(note)) {
        return notesSharedResource.hasSameId(activeNote, note) ?
            cx('highlight-shared', 'highlight-active-shared')
            : cx('highlight-shared', 'highlight-normal-shared');
    } else if (!isSharedNote(activeNote) && !isSharedNote(note)) {
        return (notesResource.hasSameId(activeNote, note)
            ? cx('highlight', 'highlight-active')
            : cx('highlight', 'highlight-normal'));
        } else if (isSharedNote(note)) {
            return cx('highlight-shared', 'highlight-normal-shared');
        } else {
            return cx('highlight', 'highlight-normal');}
    }

function getNoteTitle(note: IEntityNote, participants: IParticipant[]) {
    if (isSharedNote(note)) {
        if (participants.qWhere((itm: IParticipant)=>itm.id === note.userId).qAny()) {    
            const participantname=participants.qWhere((itm: IParticipant)=>itm.id === note.userId).qFirst().name;         
            return 'Notitie van ' + participantname + ': ' + note.text;
        } else {           
            return note.text;
        }
    } else {
        return note.text;
    }
}

const editorItemSelector = createSelector(
    notesEditor.selectors.creating,
    notesEditor.selectors.reading,
    notesEditor.selectors.updating,
    notesEditor.selectors.deleting,
    notesEditor.selectors.item,
    notesSharedEditor.selectors.reading,
    notesSharedEditor.selectors.item,
    (creating, reading, updating, deleting, item, readingshared, itemshared) => 
        (creating || reading || updating || deleting) && item || readingshared && itemshared,
);

function* monitorNoteHighlights() {
    const debounceDelay = 50;
    const slowWarningInterval = 10000;

    let _task: any;
    let prev: any;
    let clickListeners: any[] = [];
    let renderTimesIdx = 0;
    const renderTimesHistoryCount = 5;
    const renderSlowThreshold = 200;
    let giveSlowWarning = true;
    let slowWarningTimer: any = null;
    const renderTimes = new Int32Array(renderTimesHistoryCount);
    const avgRenderTime = () => renderTimes.reduce((state, next) => state + next, 0) / renderTimesHistoryCount;
    const pushRenderTime = (time: number) => { renderTimes[(renderTimesIdx++) % renderTimesHistoryCount] = time; };
    yield takeEvery([
        ...notesEditor.actions.all,
        ...notesResource.actions.all,
        ...notesSharedEditor.actions.all,
        ...notesSharedResource.actions.all,
        PAGEFILTER_CHANGE_SORTING,
        PAGEFILTER_CHANGE_CATEGORY,
        SELECTION_REQUEST,
        SELECTION_SUCCESS,
        SELECTION_RESET,
        LOGGEDOUT,
        NOTES_REDRAW,
    ], function*(action) {

        // Debounce.
        if (_task) {
            yield cancel(_task);
        }
        let _taskEff: ForkEffect = yield fork(function*() {
            yield delay(debounceDelay);

            const state: {
                categories: ICategory[];
                creatingSelection: boolean;
                currentItem: IEntityNote;
                items: IEntityNote[];
                participants: IParticipant[];
                allQuestions: IQuestionDB[];
            } = {
                    categories: yield select(categoriesResource.selectors.items),
                    creatingSelection: yield select(selectionSelectors.creating),
                    currentItem: yield select(editorItemSelector),
                    items: yield select(notesAndQuestionsPageSelector),
                    participants: yield select(participantsResource.selectors.items),
                    allQuestions: yield select(questionsResource.selectors.items),
                };
            
            if (!shallowEquals(prev, state)) {
                // const PrevCurrentItem  = prev && prev.currentItem;
                prev = state;

                for (const unsub of clickListeners) {
                    unsub();
                }
                clickListeners = [];

                const { creatingSelection, currentItem, items, participants, allQuestions } = state;

                removeHighlights(document.documentElement, '.js-note');

                const sortedNotes = items.slice(0).sort((a: IEntityNote, b: IEntityNote) => {
                    if (notesResource.hasSameId(a, currentItem)) {
                        return 1;
                    }
                    if (notesResource.hasSameId(b, currentItem)) {
                        return -1;
                    }
                    return a.startElementXPath.localeCompare(b.startElementXPath);
                });

                const onClick = (note: IEntityNote) => {
                    // tslint:disable-next-line                
                    if (notesResource.hasSameId(note, currentItem)) { 
                        hack.store.dispatch(notesEditor.actions.READ_CANCEL({}));
                        hack.store.dispatch(notesSharedEditor.actions.READ_CANCEL({}));
                        hack.store.dispatch(questionsEditor.actions.READ_CANCEL({}));
                        hack.store.dispatch(FLYOVER_HIDE({}));
                    } else {
                        // hack.store.dispatch(FLYOVER_SHOW({buttonNo: buttonNoSelection}));                   
                        if (!!isSharedNote(note)) {
                            hack.store.dispatch(notesEditor.actions.READ_CANCEL({}));
                            hack.store.dispatch(notesSharedEditor.actions.READ({ item: note }));
                        } else {
                            hack.store.dispatch(notesSharedEditor.actions.READ_CANCEL({}));
                            hack.store.dispatch(notesEditor.actions.READ({ item: note }));
                        }
                        var readquestion = false;
                        if (isQuestion(note)) {                        
                            var current = allQuestions.qWhere((x) => x.noteId === note.id).qFirst();
                            if (current) {             
                                hack.store.dispatch(questionsEditor.actions.READ({ item: current })); 
                                // on the flyover, you also have to switch tabs
                                hack.store.dispatch(TAB_ACTIVATE({ index: 1 })),
                                readquestion = true;
                            }
                        } else {
                            // on the flyover, you also have to switch tabs
                            hack.store.dispatch(TAB_ACTIVATE({ index: 0 }));
                        }
                        if (isQuestion(note) && !readquestion) {
                            hack.store.dispatch(questionsEditor.actions.READ_CANCEL({})); 
                        }

                    }   
                };

                const sortedNotesCount = sortedNotes.length;
                const anchors = getAnchorFromDocument();
                for (const note of sortedNotes) {                    
                    try {
                        const time = Date.now();               
                        yield applyHighlights(anchors, note.startElementXPath, note.endElementXPath, (node) => {
                            node.className = `${getCategoryCss(currentItem, note)} js-note`;
                            node.id = 'id-note-' + note.id.toString();
                            node.title = getNoteTitle(note, participants);
                            if (!creatingSelection) {                               
                                clickListeners.push(onClickElement(node, onClick.bind(null, note)));
                            }

                            if (currentItem.id === note.id) {
                                var ps =new PublisherSpecific();
                                ps.waitFor('#' + node.id).then((elm) => {
                                    ps.unHideHidden(node).then((topHiddenElement: HTMLElement)=> {                                 
                                    }).catch(
                                        // tslint:disable-next-line
                                        (res) => {console.log(res);}
                                    );
                                }).catch(
                                    // tslint:disable-next-line
                                    (res) => {console.log(res);}
                                );
                            }
                        });

                        // Throttle when slow
                        pushRenderTime(Date.now() - time);
                        if (avgRenderTime() * sortedNotesCount >= renderSlowThreshold) {
                            if (giveSlowWarning) {
                                const tooSlowMultiplier = (avgRenderTime() * sortedNotesCount) / renderSlowThreshold;
                                // tslint:disable-next-line
                                console.warn(`[NoteService] Rendering notes progressive, due to slow performance: ${sortedNotes.length} notes, ${(1000 / avgRenderTime()).toFixed(1)}notes/sec (${(tooSlowMultiplier).toFixed(1)}x too slow). May cause flickering.`);
                                giveSlowWarning = false;
                            }
                            if (!slowWarningTimer) {
                                slowWarningTimer = setTimeout(() => {
                                    slowWarningTimer = null;
                                    giveSlowWarning = true;
                                }, slowWarningInterval);
                            }
                            yield;
                        } else if (!giveSlowWarning) {
                            // Restore when performant
                            // tslint:disable-next-line
                            console.warn(`[NoteService] Rendering notes instantly: ${sortedNotes.length} notes, ${(1000 / avgRenderTime()).toFixed(1)}notes/sec.`);
                            giveSlowWarning = true;
                        }
                    } catch (ex) {
                        if (ex.message === 'No matching node') {
                            continue;
                        }
                        // tslint:disable-next-line
                        console.error(`[NoteService] Failed to render note [${note.startElementXPath}:${note.endElementXPath}]: ${ex.message}`);
                    }
                }
            }
        });
        _task =_taskEff;
    });
}

function* monitorBrowserRestoreActiveNote() {
    yield takeEvery([SESSION_RESTORED, NOTES_ITEM_LAST_TOUCHED], function*(action) {
        if (currentitem !== undefined) {
            if (hack.store.getState()) {                               
                // console.log(action);
                const curitem: any = currentitem.currentitem(hack.store.getState());
                if (!!isSharedNote(curitem)) {       
                    const item: INoteShared = curitem;                    
                    yield call(delay, delayafterreload),
                    yield put(notesSharedEditor.actions.READ({ item: item }));  
                    yield put(notesEditor.actions.READ_CANCEL({}));              
                } else if (!!isNote(curitem)) { 
                    const item: INote = curitem;                    
                    yield call(delay, delayafterreload),
                    yield put(notesEditor.actions.READ({ item: item }));  
                    yield put(notesSharedEditor.actions.READ_CANCEL({}));
                }
                var readquestion = false;
                if (isQuestion(curitem)) {
                    const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);
                    const currentitem = questions.qWhere((x) => x.noteId === curitem.id).qFirst();
                    if (currentitem) {    
                        yield put(questionsEditor.actions.READ({ item: currentitem }));
                        readquestion = true;  
                    }                       
                }  
                if (isQuestion(curitem) && !readquestion) {
                    yield put(questionsEditor.actions.READ_CANCEL({}));
                }

                if (isType(action, SESSION_RESTORED)) {
                    yield put(NOTES_ITEM_LAST_TOUCHED({item: undefined}));
                }
            }
        }
    });
}

function onClickElement(el: Node, onClick: () => void) {
    el.addEventListener('click', onClick);
    return () => {
        el.removeEventListener('click', onClick);
    };
}

function shallowEquals<T>(a: T, b: T): boolean {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }

    const keys = [...Object.keys(a), ...Object.keys(b)].qDistinct();
    return keys.every((x) => a[x] === b[x]);
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/sagas.tsx